<template>
  <div class="faq-gift-box">
    <section class="discover-section faq-section">
      <div class="container-fluid">
        <div class="add-padding">
          <div class="selection-btns-container w-100 mb-4">
            <div class="selection-button" :class="selectedType === 'entreprise' ? 'selected' : ''" @click="selectedType = 'entreprise'">
              FAQ - PARTICULIERS
            </div>
            <div class="selection-button" :class="selectedType === 'cse-collective' ? 'selected' : ''" @click="selectedType = 'cse-collective'">
              FAQ - ENTREPRISES & CSE
            </div>
          </div>
          <div class="top-content d-flex justify-content-center align-items-center">
            <p  class="mb-0" :class="isPhone ? 'merriweather-reg-20 text-center' : 'merriweather-reg-24'">FAQ - Nos coffrets cadeaux Hortense</p>
          </div>
          <div class="accordion mt-5" id="faqAccordion" v-if="selectedType === 'entreprise'">
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                >
                    Qu'est-ce que le coffret cadeau Hortense ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseOne"
                    class="collapse"
                    aria-labelledby="headingOne"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Le coffret cadeau Hortense est une invitation à vivre une évasion éco-responsable dans des hébergements de charme triés sur le volet. Il permet d'offrir – ou de s'offrir – un séjour unique dans des lieux engagés, alliant confort, authenticité et respect de l'environnement. Chaque coffret comprend une carte cadeau utilisable librement sur l'ensemble de notre sélection d'adresses, avec 24 mois pour réserver l'expérience de votre choix.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 2 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                >
                    À qui s'adresse ce coffret cadeau ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwo"
                    class="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Il s'adresse à toutes les personnes en quête d'évasion, de nature, d'authenticité et de sens. Il est parfait pour les amateurs de belles adresses, les voyageurs soucieux de leur impact et les amoureux de séjours éco-responsables.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 3 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                >
                    Peut-on offrir un coffret sans connaître la date du futur séjour ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThree"
                    class="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui, absolument. Le bénéficiaire est libre de choisir la date et l'hébergement qui lui conviennent, dans la limite de validité de la carte cadeau, fixée à 24 mois à compter de la date d'achat.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 4 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                >
                    Comment le bénéficiaire utilise-t-il le coffret ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseFour"
                    class="collapse"
                    aria-labelledby="headingFour"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Le bénéficiaire se rend sur notre site hortense.green, explore notre sélection d'hébergements éco-responsables et choisit celui qui lui plaît. Lors de la réservation, il saisit le code de sa carte cadeau dans le champ prévu à cet effet pour utiliser son crédit.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 5 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                >
                    Est-ce que le coffret est nominatif ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseFive"
                    class="collapse"
                    aria-labelledby="headingFive"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Non, le coffret n'est pas nominatif. Il peut être offert à la personne de votre choix, qui pourra ensuite réserver en toute autonomie.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 6 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                >
                    Que contient le coffret cadeau Hortense ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseSix"
                    class="collapse"
                    aria-labelledby="headingSix"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Un coffret comprend :</p>
                        <ul>
                            <li>une carte cadeau d'un montant libre entre 100 € et 1000 €,</li>
                            <li>un guide de voyage "Découvrez la France autrement",</li>
                            <li>une pochette éco-friendly,</li>
                            <li>un service de conciergerie sur-mesure,</li>
                            <li>un privilège exclusif (avantage ou expérience en plus selon l'hébergement).</li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Question 7 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseSeven"
                    aria-expanded="false"
                    aria-controls="collapseSeven"
                >
                    Qu'est-ce que le guide de voyage "Découvrez la France autrement" ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseSeven"
                    class="collapse"
                    aria-labelledby="headingSeven"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            C'est un ouvrage de 300 pages mêlant hébergements engagés, itinéraires de voyages, conseils concrets et sensibilisation aux enjeux du tourisme durable.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 11 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseEleven"
                    aria-expanded="false"
                    aria-controls="collapseEleven"
                >
                    En quoi consiste le "privilège exclusif" offert dans le coffret ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseEleven"
                    class="collapse"
                    aria-labelledby="headingEleven"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Le privilège exclusif est un avantage réservé aux détenteurs d'un coffret cadeau Hortense, équivalent à celui offert aux membres au statut Green Trotter sur notre plateforme.
                        </p>
                        <p>
                            Ce privilège varie selon l'hébergement : il peut s'agir d'un accueil gourmand, d'un accès privilégié à un espace bien-être, d'une activité offerte, ou encore d'un cadeau local. Chaque lieu propose une attention différente, pensée pour enrichir l'expérience du séjour.
                        </p>
                        <p>
                            Les détails du privilège sont précisés sur la fiche de chaque hébergement au moment de la réservation.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 12 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwelve"
                    aria-expanded="false"
                    aria-controls="collapseTwelve"
                >
                    Quel montant peut-on offrir avec la carte cadeau ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwelve"
                    class="collapse"
                    aria-labelledby="headingTwelve"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            De 100 € à 1000 €, selon votre budget. Vous choisissez le montant librement.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 13 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThirteen"
                    aria-expanded="false"
                    aria-controls="collapseThirteen"
                >
                    La carte cadeau est-elle valable sur tous les hébergements du site ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThirteen"
                    class="collapse"
                    aria-labelledby="headingThirteen"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui, elle est valable sur l'ensemble du catalogue d'hébergements du site hortense.green, sans restriction.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 14 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFourteen"
                    aria-expanded="false"
                    aria-controls="collapseFourteen"
                >
                    Combien de temps est valable la carte cadeau ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseFourteen"
                    class="collapse"
                    aria-labelledby="headingFourteen"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Elle est valable <strong>2 ans</strong> (24 mois) à partir de la date d'achat.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 15 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFifteen"
                    aria-expanded="false"
                    aria-controls="collapseFifteen"
                >
                    Peut-on utiliser plusieurs cartes cadeaux pour une même réservation ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseFifteen"
                    class="collapse"
                    aria-labelledby="headingFifteen"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Non, la carte cadeau <strong>n'est pas</strong> cumulable avec d'autres cartes cadeau Hortense. Une seule carte peut être utilisée par réservation.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 16 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseSixteen"
                    aria-expanded="false"
                    aria-controls="collapseSixteen"
                >
                    Peut-on utiliser un code promotionnel ou un avantage exclusif avec une carte cadeau ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseSixteen"
                    class="collapse"
                    aria-labelledby="headingSixteen"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui. Il est possible d'appliquer un <strong>code exclusif</strong> au moment de la réservation, <strong>en complément</strong> d'une carte cadeau.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 17 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseSeventeen"
                    aria-expanded="false"
                    aria-controls="collapseSeventeen"
                >
                    La carte est-elle utilisable en plusieurs fois ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseSeventeen"
                    class="collapse"
                    aria-labelledby="headingSeventeen"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Non. La <strong>carte est utilisable en une seule fois</strong>, quel que soit le montant du séjour.
                        </p>
                        <p>
                            Si le montant du séjour dépasse la valeur de la carte, le bénéficiaire peut compléter par carte bancaire.
                        </p>
                        <p>
                            Si le montant est inférieur, <strong>le solde est perdu</strong>, il n'est pas conservé.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 18 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseEighteen"
                    aria-expanded="false"
                    aria-controls="collapseEighteen"
                >
                    Quelle est la différence entre le coffret physique et le e-coffret ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseEighteen"
                    class="collapse"
                    aria-labelledby="headingEighteen"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            <strong>E-coffret :</strong> il est 100 % numérique et envoyé immédiatement par e-mail.
                        </p>
                        <p>
                            <strong>Coffret physique (29 €):</strong> livré à l'adresse indiquée lors de l'achat, il contient tous les éléments en version imprimée (livret, carte, pochette…).
                        </p>
                        <p>
                            <strong>Tous les bénéficiaires reçoivent également un e-coffret par e-mail</strong>, même si vous choisissez un coffret physique. Cela permet d'assurer la réception immédiate et d'éviter toute perte.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 19 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseNineteen"
                    aria-expanded="false"
                    aria-controls="collapseNineteen"
                >
                    Quand recevra-t-on le e-coffret ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseNineteen"
                    class="collapse"
                    aria-labelledby="headingNineteen"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Le e-coffret est envoyé <strong>automatiquement par e-mail dès la validation de la commande</strong>, quelle que soit l'option choisie (physique ou numérique).
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 20 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwenty"
                    aria-expanded="false"
                    aria-controls="collapseTwenty"
                >
                    Quels sont les délais de livraison pour le coffret physique ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwenty"
                    class="collapse"
                    aria-labelledby="headingTwenty"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            La livraison prend généralement entre 3 et 7 jours ouvrés en <strong>France métropolitaine</strong>.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 21 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwentyOne"
                    aria-expanded="false"
                    aria-controls="collapseTwentyOne"
                >
                    Dans quels pays livrez-vous le coffret physique ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwentyOne"
                    class="collapse"
                    aria-labelledby="headingTwentyOne"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Pour l'instant, la livraison du coffret physique est uniquement disponible en France métropolitaine.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 22 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwentyTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwentyTwo"
                >
                    Puis-je faire livrer le coffret cadeau à une autre adresse ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwentyTwo"
                    class="collapse"
                    aria-labelledby="headingTwentyTwo"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui, vous pouvez indiquer une adresse différente lors de la commande pour un envoi direct au destinataire.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 24 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwentyFour"
                    aria-expanded="false"
                    aria-controls="collapseTwentyFour"
                >
                    Qu'est-ce que le service de conciergerie sur-mesure ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwentyFour"
                    class="collapse"
                    aria-labelledby="headingTwentyFour"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Un service d'accompagnement personnalisé pour aider le bénéficiaire à choisir, réserver et organiser son séjour selon ses envies.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 25 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwentyFive"
                    aria-expanded="false"
                    aria-controls="collapseTwentyFive"
                >
                    Qui bénéficie du service de conciergerie ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwentyFive"
                    class="collapse"
                    aria-labelledby="headingTwentyFive"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Le service de conciergerie est exclusivement réservé au bénéficiaire du coffret cadeau Hortense, après la réservation de son séjour sur notre site.
                        </p>
                        <p>
                            Ce service personnalisé permet de l'accompagner dans la préparation de son escapade : recommandations d'activités locales, adresses engagées, expériences à vivre sur place… Notre équipe est à ses côtés pour créer un séjour à son image, en toute sérénité.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 26 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwentySix"
                    aria-expanded="false"
                    aria-controls="collapseTwentySix"
                >
                    Comment contacter la conciergerie Hortense ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwentySix"
                    class="collapse"
                    aria-labelledby="headingTwentySix"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Une fois votre séjour réservé avec un coffret cadeau Hortense, vous pouvez contacter notre conciergerie par e-mail à l'adresse suivante : <a class="link-hortense" href="mailto:customercare@hortense.green">customercare@hortense.green</a>.
                        </p>
                        <p>
                            Notre équipe se tient à votre disposition pour vous accompagner dans la préparation de votre séjour et vous proposer des suggestions personnalisées selon vos envies et votre destination.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 27 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwentySeven"
                    aria-expanded="false"
                    aria-controls="collapseTwentySeven"
                >
                    Le coffret est-il éco-responsable ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwentySeven"
                    class="collapse"
                    aria-labelledby="headingTwentySeven"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui, l'éco-conception est au cœur du projet : matériaux durables, zéro plastique, réduction des impressions inutiles.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 28 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwentyEight"
                    aria-expanded="false"
                    aria-controls="collapseTwentyEight"
                >
                    Quels types de matériaux utilisez-vous pour le coffret physique ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwentyEight"
                    class="collapse"
                    aria-labelledby="headingTwentyEight"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Le coffret physique Hortense est conçu avec des matériaux éco-responsables, pensés pour minimiser leur impact environnemental tout en offrant une expérience raffinée.
                        </p>
                        <p>
                            La pochette qui contient le coffret est en coton biologique certifié GOTS, éco-conçue, élégante et réutilisable.
                        </p>
                        <p>
                            Les différents éléments papier inclus dans le coffret – notamment la carte cadeau physique – sont imprimés sur du papier ensemencé, qui peut être planté pour faire pousser des fleurs des champs. Une façon symbolique et poétique de faire germer le souvenir du voyage.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 29 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwentyNine"
                    aria-expanded="false"
                    aria-controls="collapseTwentyNine"
                >
                    Le e-coffret est-il une alternative durable ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwentyNine"
                    class="collapse"
                    aria-labelledby="headingTwentyNine"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui, 100 % dématérialisé, il est idéal pour limiter son empreinte écologique et offrir en dernière minute.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 30 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThirty"
                    aria-expanded="false"
                    aria-controls="collapseThirty"
                >
                    Les hébergements proposés sont-ils tous engagés dans une démarche durable ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThirty"
                    class="collapse"
                    aria-labelledby="headingThirty"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui, tous les hébergements proposés par Hortense sont sélectionnés pour leur engagement environnemental et social. Nous avons à cœur de ne proposer que des lieux qui partagent nos valeurs : respect de la nature, ancrage local, consommation responsable, gestion des ressources, etc.
                        </p>
                        <p>
                            Chaque hébergement fait l'objet d'une évaluation selon notre propre indicateur : la Green Note, qui prend en compte plus de 150 critères de durabilité. Cette note permet de valoriser les démarches engagées et d'apporter plus de transparence aux voyageurs en quête d'un tourisme plus responsable.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 31 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThirtyOne"
                    aria-expanded="false"
                    aria-controls="collapseThirtyOne"
                >
                    Peut-on ajouter un message personnalisé au coffret ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThirtyOne"
                    class="collapse"
                    aria-labelledby="headingThirtyOne"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui, lors de la commande, vous pouvez rédiger un message qui sera inclus dans le e-mail ou dans le coffret.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 33 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThirtyThree"
                    aria-expanded="false"
                    aria-controls="collapseThirtyThree"
                >
                    Peut-on offrir un coffret en dernière minute ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThirtyThree"
                    class="collapse"
                    aria-labelledby="headingThirtyThree"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui, le e-coffret est parfait pour cela : il est envoyé instantanément après l'achat.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 34 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThirtyFour"
                    aria-expanded="false"
                    aria-controls="collapseThirtyFour"
                >
                    Puis-je échanger ou me faire rembourser un coffret cadeau ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThirtyFour"
                    class="collapse"
                    aria-labelledby="headingThirtyFour"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Tout achat est ferme et définitif. Le droit de rétractation ne s'applique pas aux coffrets cadeaux Hortense.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 35 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThirtyFive"
                    aria-expanded="false"
                    aria-controls="collapseThirtyFive"
                >
                    Y a-t-il des frais supplémentaires à prévoir pour le bénéficiaire ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThirtyFive"
                    class="collapse"
                    aria-labelledby="headingThirtyFive"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Oui, des frais peuvent s'appliquer au-delà de la valeur de la carte cadeau.
                        </p>
                        <p>
                            Si le montant du séjour choisi dépasse la valeur de la carte, le bénéficiaire devra simplement régler la différence au moment de la réservation.
                        </p>
                        <p>
                            Par ailleurs, certaines consommations ou prestations sur place (repas, soins bien-être, activités supplémentaires, taxe de séjour, etc.) peuvent également entraîner des frais à régler directement auprès de l'hébergement.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 36 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThirtySix"
                    aria-expanded="false"
                    aria-controls="collapseThirtySix"
                >
                    Comment savoir si un hébergement est disponible ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThirtySix"
                    class="collapse"
                    aria-labelledby="headingThirtySix"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            La disponibilité des hébergements est visible en temps réel sur notre site hortense.green. Vous pouvez effectuer votre réservation directement en ligne, en toute autonomie.
                        </p>
                        <p>
                            Certains hébergements fonctionnent en réservation sur demande : dans ce cas, vous remplissez une demande via notre formulaire et l'équipe de l'hébergement vous répondra rapidement pour confirmer ou proposer une alternative.
                        </p>
                        <p>
                            Les réservations sont possibles toute l'année, sans restriction de période, sous réserve de disponibilité. Il est toutefois recommandé d'anticiper pour bénéficier d'un plus large choix de dates et de lieux.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 37 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThirtySeven"
                    aria-expanded="false"
                    aria-controls="collapseThirtySeven"
                >
                    Y a-t-il des dates d'exclusion (périodes non réservable) ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThirtySeven"
                    class="collapse"
                    aria-labelledby="headingThirtySeven"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            Non, tous les hébergements sont disponibles toute l'année, sous réserve de disponibilité.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 38 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' "
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThirtyEight"
                    aria-expanded="false"
                    aria-controls="collapseThirtyEight"
                >
                    Puis-je prolonger la validité de mon coffret ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThirtyEight"
                    class="collapse"
                    aria-labelledby="headingThirtyEight"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>
                            <strong>Non. Aucune prolongation ne sera accordée</strong>, même à titre exceptionnel. Le coffret est valable <strong>24 mois à compter de sa date d'achat</strong>, et il est de la responsabilité du bénéficiaire de l'utiliser dans ce délai.
                        </p>
                    </div>
                </div>
            </div>
          </div>
          <div class="accordion mt-5" id="faqAccordion" v-else>
            <!-- Question 1 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    À qui s'adresse l'offre coffret cadeau Hortense en BtoB ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>L'offre coffret cadeau Hortense en BtoB s'adresse aux entreprises, CSE, agences événementielles, distributeurs ou associations souhaitant offrir un cadeau porteur de sens à leurs collaborateurs, clients ou partenaires. Nos coffrets permettent d'offrir une expérience unique, responsable et mémorable, en lien avec les valeurs d'un tourisme durable. Ils s'intègrent parfaitement dans une démarche RSE, une opération de fidélisation, une dotation événementielle ou un programme d'incentive.</p>
                    </div>
                </div>
            </div>

            <!-- Question 2 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Dans quels cas offrir un coffret Hortense ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Le coffret Hortense est une idée cadeau idéale pour les entreprises, CSE et associations souhaitant valoriser, fidéliser ou remercier de manière engagée. Il peut être offert dans de nombreux contextes professionnels :<br>
                        - Cadeaux de fin d'année<br>
                        - Récompenses ou challenges commerciaux<br>
                        - Opérations de fidélisation ou d'incentive<br>
                        - Dotations événementielles ou animations CSE<br>
                        - Actions RSE ou QVT (Qualité de Vie au Travail)<br>
                        Avec Hortense, vous offrez plus qu'un cadeau : une expérience éco-responsable, authentique et mémorable, en parfaite cohérence avec vos valeurs.</p>
                    </div>
                </div>
            </div>

            <!-- Question 3 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Comment fonctionne le coffret pour l'entreprise ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Vous choisissez le nombre de coffrets, le format (physique ou e-coffret), le montant unitaire de la carte cadeau (entre 100 € et 1000 €) et les options (guide papier, message personnalisé, livraison groupée ou individuelle).</p>
                    </div>
                </div>
            </div>

            <!-- Question 4 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Peut-on personnaliser les coffrets aux couleurs de notre entreprise ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui, nous proposons des options de personnalisation sur mesure pour les entreprises. Il est possible d'ajouter votre logo, un mot personnalisé pour les bénéficiaires, ou même de créer un habillage aux couleurs de votre marque (coffret, pochette, carte cadeau, insert). Cette personnalisation permet d'offrir un cadeau à votre image, à la fois élégant et engagé. Notre équipe vous accompagne pour concevoir un coffret unique, en cohérence avec votre message et vos valeurs.</p>
                    </div>
                </div>
            </div>

            <!-- Question 5 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    Que contient chaque coffret Hortense ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Un coffret comprend :</p>
                        <ul>
                          <li>une carte cadeau d'un montant libre entre 100 € et 1000 €,</li>
                          <li>un guide de voyage "Découvrez la France autrement",</li>
                          <li>une pochette éco-friendly,</li>
                          <li>un service de conciergerie sur-mesure,</li>
                        </ul>
                        <p>un privilège exclusif (avantage ou expérience en plus selon l'hébergement).</p>
                    </div>
                </div>
            </div>

            <!-- Question 6 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    Quelles sont les options disponibles ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <ul>
                          <li>E-coffret (immédiat) ou coffret physique</li>
                          <li>Livraison en un point unique ou dispatch à plusieurs adresses</li>
                          <li>Personnalisation graphique ou éditoriale</li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Question 7 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                    Tous les collaborateurs recevront-ils le même contenu ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui, sauf si vous choisissez des montants de carte cadeau ou des options différentes par bénéficiaire.</p>
                    </div>
                </div>
            </div>

            <!-- Question 8 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                    Existe-t-il un minimum de commande pour les entreprises ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Pas de minimum imposé, mais des tarifs dégressifs sont appliqués à partir de 50 coffrets.</p>
                    </div>
                </div>
            </div>

            <!-- Question 9 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                    Quels sont les délais à prévoir ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                      Les délais varient selon le <strong>volume de coffrets commandés</strong> et le <strong>mode d'envoi choisi</strong> (par Hortense ou par votre entreprise).<br><br>
                      <ul>
                        <li>Pour les <strong>coffrets physiques</strong> (avec pochette en coton bio et carte cadeau papier), il faut compter un délai de <strong>30 à 45 jours ouvrés</strong> à partir de la validation de commande.</li>
                        <li>Pour les <strong>e-coffrets</strong> (version digitale envoyée par e-mail), le délai est généralement de <strong>10 à 20 jours ouvrés</strong>, selon le niveau de personnalisation souhaité.</li>
                      </ul>
                      <p>Nous vous conseillons d'anticiper vos demandes, notamment en période de forte activité (fêtes de fin d'année, événements internes, etc.), afin de garantir une livraison dans les temps.</p>
                    </div>
                </div>
            </div>

            <!-- Question 10 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                    Peut-on livrer les coffrets à domicile ou au bureau ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui. Livraison possible en un point unique ou envois individuels en France métropolitaine.</p>
                    </div>
                </div>
            </div>

            <!-- Question 11 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                    Peut-on commander toute l'année ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseEleven" class="collapse" aria-labelledby="headingEleven" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui. L'offre est disponible à tout moment, avec un accompagnement dédié pour les temps forts (Noël, été, rentrée, etc.).</p>
                    </div>
                </div>
            </div>

            <!-- Question 12 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve">
                    Les coffrets cadeaux sont-ils exonérés de cotisations sociales ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseTwelve" class="collapse" aria-labelledby="headingTwelve" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui, dans la limite du plafond URSSAF en vigueur (5 % du plafond mensuel de la Sécurité sociale, soit environ 193 € par événement en 2025).<br><br>
                        Au-delà de ce montant, des <strong>charges sociales peuvent s'appliquer</strong>, sauf cas particuliers prévus par l'URSSAF. Ce plafond s'applique notamment aux cadeaux offerts à l'occasion d'événements reconnus (mariage, naissance, Noël, rentrée scolaire, etc.).</p>
                    </div>
                </div>
            </div>

            <!-- Question 13 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen">
                    Fournissez-vous une facture avec TVA ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseThirteen" class="collapse" aria-labelledby="headingThirteen" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui, toutes nos commandes BtoB donnent lieu à une facture claire avec TVA récupérable (selon votre régime fiscal).</p>
                    </div>
                </div>
            </div>

            <!-- Question 14 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseFourteen" aria-expanded="false" aria-controls="collapseFourteen">
                    Peut-on régler par virement ou mandat administratif ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseFourteen" class="collapse" aria-labelledby="headingFourteen" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui, nous acceptons les paiements par virement, mandat ou carte bancaire. Contactez-nous pour un devis à l'adresse </p><a class="link-hortense" href="mailto:servicecorporate@hortense.green">servicecorporate@hortense.green</a>
                    </div>
                </div>
            </div>

            <!-- Question 15 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseFifteen" aria-expanded="false" aria-controls="collapseFifteen">
                    Les collaborateurs peuvent-ils réserver librement leur séjour ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseFifteen" class="collapse" aria-labelledby="headingFifteen" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui, chaque bénéficiaire choisit sa destination et son hébergement parmi notre catalogue d'adresses engagées.</p>
                    </div>
                </div>
            </div>

            <!-- Question 16 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseSixteen" aria-expanded="false" aria-controls="collapseSixteen">
                    La carte cadeau est-elle valable sur tous les hébergements ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseSixteen" class="collapse" aria-labelledby="headingSixteen" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui, sans exception. Elle est utilisable sur tous les établissements référencés sur notre plateforme.</p>
                    </div>
                </div>
            </div>

            <!-- Question 17 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseSeventeen" aria-expanded="false" aria-controls="collapseSeventeen">
                    Combien de temps la carte cadeau est-elle valable ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseSeventeen" class="collapse" aria-labelledby="headingSeventeen" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>24 mois à partir de la date d'émission.</p>
                    </div>
                </div>
            </div>

            <!-- Question 18 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseEighteen" aria-expanded="false" aria-controls="collapseEighteen">
                    En quoi le coffret Hortense est-il une alternative responsable ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseEighteen" class="collapse" aria-labelledby="headingEighteen" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <ul>
                        <li>Aucun suremballage</li>
                        <li>Impression raisonnée</li>
                        <li>Matières recyclées</li>
                        <li>Hébergements engagés en faveur du tourisme durable</li>
                        <li>Valorisation du tourisme local, lent et durable</li>
                        <li>Version numérique disponible</li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Question 19 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseNineteen" aria-expanded="false" aria-controls="collapseNineteen">
                    L'offre est-elle compatible avec notre politique RSE ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseNineteen" class="collapse" aria-labelledby="headingNineteen" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Parfaitement. Elle vous permet de valoriser vos engagements tout en renforçant le bien-être au travail.</p>
                    </div>
                </div>
            </div>

            <!-- Question 20 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseTwenty" aria-expanded="false" aria-controls="collapseTwenty">
                    Proposez-vous un accompagnement dédié aux entreprises ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseTwenty" class="collapse" aria-labelledby="headingTwenty" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Oui, un interlocuteur vous est attribué pour concevoir votre opération, vous conseiller et assurer le suivi jusqu'à la livraison.</p>
                    </div>
                </div>
            </div>

            <!-- Question 21 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseTwentyOne" aria-expanded="false" aria-controls="collapseTwentyOne">
                    Et si un collaborateur perd son e-mail ou sa carte ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseTwentyOne" class="collapse" aria-labelledby="headingTwentyOne" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Nous pouvons rééditer le code ou renvoyer le e-coffret sur simple demande (avec preuve d'achat).</p>
                    </div>
                </div>
            </div>

            <!-- Question 22 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseTwentyTwo" aria-expanded="false" aria-controls="collapseTwentyTwo">
                    Les coffrets sont-ils échangeables ou remboursables ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseTwentyTwo" class="collapse" aria-labelledby="headingTwentyTwo" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Non, les coffrets Hortense ne sont ni échangeables ni remboursables, conformément à l'article L221-28 du Code de la consommation relatif aux biens personnalisés et aux prestations de services datées.<br><br>
                        Une fois le coffret commandé, il ne peut faire l'objet d'un retour ou d'un remboursement. Cependant, le bénéficiaire dispose de 24 mois pour réserver librement le séjour de son choix parmi l'ensemble de notre collection.</p>
                    </div>
                </div>
            </div>

            <!-- Question 23 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 " :class="isPhone ? 'pl-2' : 'pl-4' " type="button" data-toggle="collapse" data-target="#collapseTwentyThree" aria-expanded="false" aria-controls="collapseTwentyThree">
                    Comment faire une demande de devis ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseTwentyThree" class="collapse" aria-labelledby="headingTwentyThree" data-parent="#faqAccordion">
                    <div class="card-body " :class="isPhone ? 'pl-2' : 'pl-4' ">
                        <p>Il suffit de nous écrire via <a class="link-hortense" href="mailto:servicecorporate@hortense.green">servicecorporate@hortense.green</a> ou via le formulaire en bas de page. Un devis personnalisé vous sera envoyé sous 48h.</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'gift-box-faq',
  data() {
    return {
      isPhone: window.innerWidth <= 768,
      selectedType: 'entreprise'
    };
  },
  mounted() {
    if (window.location.pathname === '/faq-coffrets-cadeaux-entreprise') {
      this.selectedType = 'cse-collective';
    }
  }
};
</script>
<style scoped lang="scss">
  .discover-section {
    .top-content {
      background: #CFE5DC77 0% 0% no-repeat padding-box;
      margin: 0 25% 0 25%;
      @media screen and (max-width: 768px) {
        margin: 0 3% 0 3%;
      }
      p {
        padding: 29px 0;

        @media screen and (max-width: 768px) {
          padding: 24px 33px;
        }
      }
    }

    .cards-box {
      .bottom-content {
        h3 {
          font-size: 16px;
          margin-bottom: 13px;
        }

        p {
          font-size: 16px;
        }
      }
    }
  }
  .faq-section {
    margin-top: 55px;

    @media screen and (max-width: 768px) {
      margin-top: 120px;
    }
    .top-content {
      h2 {
        font-size: 40px;
      }
    }

    #faqAccordion {
      padding: 0 9%;
      @media screen and (max-width: 768px) {
        padding: 0 2%;
      }
    }

    .btn-link {
      color: white;
      text-decoration: none;
      font-weight: 600;
      display: block;
      text-align: left;
      width: 100%;
      background-color: #365a48;
      border-bottom: none;
      padding-left: 0;
      padding: 10px 0px;
      transition: padding 0.3s ease-in-out;
      box-shadow: none;
      border-radius: 0px;
      font-size: 16px;
      line-height: 20px;
      font-family: "Raleway", sans-serif;
      align-items: center;
      gap: 12px;
      text-transform: uppercase;
    }

    .btn-link.collapsed {
      color: #000000;
      background-color: #ffffff;
      padding-left: 20px;

      &:hover {
        background-color: #365a48;
        color: #ffffff;
      }
    }

    .card {
      border: none;
      margin-bottom: 10px;
    }

    .card-body {
      p,
      li, a {
        font-size: 16px;
        color: #000000;
        font-family: "Raleway", sans-serif;
        margin-bottom: 0;
        line-height: 35px;

        span {
          font-weight: 700;
        }
        &.external-links {
          a {
            color: #000000;
            text-decoration: underline;
          }
        }
      }

      ul {
        padding-left: 20px;
      }
    }

    .arrow-icon {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-right: 2px solid white;
      border-bottom: 2px solid white;
      transform: rotate(45deg);
      transition: transform 0.3s ease;
      margin-left: 10px;
    }

    /* Rotate arrow when expanded */
    button[aria-expanded="false"] i {
      transform: rotate(180deg);
    }
  }

  .selection-btns-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;

    @media screen and (max-width: 768px) {
      gap: 6px;
      flex-direction: column;
    }

    .selection-button {
      padding: 19px;
      border-radius: 19px;
      border: 2px solid #3B6152;
      color: #3B6152;
      width: 251px;
      height: 37px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: $Raleway;
      font-weight: 600;
      font-size: 15px;
      cursor: pointer;
    }
    .selected {
      background-color: #3B6152;
      color: white;
    }
  }
</style>